import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Configuration } from '../shared/services/configuration';
import { ConfirmationData } from './confirmation-data-model';

@Component({
    selector: 'confirmationModel',
    templateUrl: 'confirmationModel.html'
})
export class ConfirmationModel {
    @Input()
    public data: ConfirmationData;
    public disabledButton: boolean = false;
    constructor(
        public activeModal: NgbActiveModal,
        public _global: Configuration) {
        this.data = null;
    }

    public setData(data) {
        if (data) {
            if (!data.isErrorMessage && data.confirmationMessage == null || data.confirmationMessage == "") {
                data.confirmationMessage = 'areYouSure';
            }

            if (data.noButtonText == null || data.noButtonText.trim() == "") {
                data.noButtonText = "no"
            }

            if (data.yesButtonText == null || data.yesButtonText.trim() == "") {
                data.yesButtonText = "yes"
            }
            this.data = data;
        }
    }

    public continue() {
        this.disabledButton = true;
        this.activeModal.close("CONTINUE");
    }

    public close() {
        this.disabledButton = true;
        this.activeModal.close("CANCEL");
    }



}



// WEBPACK FOOTER //
// ./src/app/confirmation/confirmationModel.ts